export const REFRESH_TOKEN_EXPIRE_AT_COOKIE_KEY = 'refresh_token_expires_at';
